/* global VXConfig */
import { useEffect, useState } from 'react';

const _TRANSLATIONS = {
	MyVisitXMediathek: 'MyVisitXMediathek',
	MyVisitXAchievement: 'MyVisitXAchievement',
	MyVisitXProfileOnboarding: 'MyVisitXProfileOnboarding',
	Rosenrausch: 'Rosenrausch',
};

let _translations = {};
let _translationFetch = {};

const getTranslation = (translations, key, ...args) => {
	const translation = translations[key];
	let out = typeof translation === 'string' ? translation : '';

	if (args.length > 0) {
		for (let i = 0; i < args.length; i++) {
			out = out.replace('%s', args[i]);
		}
	}
	return out;
};

function getTranslationFilename(category) {
	switch (category) {
		case _TRANSLATIONS.MyVisitXMediathek:
			return window.categoriesTranslations['myvisitx_mediathek'];
		case _TRANSLATIONS.MyVisitXAchievement:
			return window.categoriesTranslations['myvisitx_achievement'];
		case _TRANSLATIONS.MyVisitXProfileOnboarding:
			return window.categoriesTranslations['myvisitx_profile-onboarding'];
		case _TRANSLATIONS.Rosenrausch:
			return window.categoriesTranslations['_event-rosenrausch'];
	}
	return '';
}

function fetchTranslation(category, lang) {
	const file = getTranslationFilename(category);
	if (_translationFetch[category] && _translationFetch[category][lang]) {
		return _translationFetch[category][lang];
	}

	if (!_translationFetch[category]) {
		_translationFetch[category] = {};
	}

	_translationFetch[category][lang] = fetch(file[lang]).then((res) => res.json());

	return _translationFetch[category][lang];
}

function useTranslation(category) {
	const lang = VXConfig.language;
	const [translations, setTranslations] = useState(_translations);

	useEffect(() => {
		if (!translations || !translations[category] || !translations[category][lang]) {
			fetchTranslation(category, lang).then((fetchedTranslations) => {
				if (!_translations[category]) {
					_translations[category] = {};
				}
				_translations[category][lang] = fetchedTranslations;
				setTranslations({ ..._translations });
			});
		}
	}, [category, translations, lang]);
	if (!translations || !translations[category] || !translations[category][lang]) {
		return () => '';
	}

	return (key, ...args) => getTranslation(translations[category][lang], key, ...args);
}

function useMyVisitXMediathekTranslation() {
	return useTranslation(_TRANSLATIONS.MyVisitXMediathek);
}

function useMyVisitXAchievementTranslation() {
	return useTranslation(_TRANSLATIONS.MyVisitXAchievement);
}

function useMyVisitXProfileOnboardingTranslation() {
	return useTranslation(_TRANSLATIONS.MyVisitXProfileOnboarding);
}

function useRosenrauschTranslation() {
	return useTranslation(_TRANSLATIONS.Rosenrausch);
}

export { useMyVisitXMediathekTranslation, useMyVisitXAchievementTranslation, useRosenrauschTranslation, useMyVisitXProfileOnboardingTranslation };
